// import { useEffect, useRef, useState } from "react";

// const images = [
//   "/images/slider1.webp",
//   "/images/slider2.webp",
//   "/images/slider3.webp",
//   "/images/slider4.webp",
// ];

// export default function Slider() {
//   const [current, setCurrent] = useState(0);
//   const timeoutRef = useRef(null);
//   const delay = 5000;

//   const nextSlide = () => setCurrent((prev) => (prev + 1) % images.length);
//   const prevSlide = () =>
//     setCurrent((prev) => (prev - 1 + images.length) % images.length);

//   useEffect(() => {
//     timeoutRef.current = setTimeout(nextSlide, delay);
//     return () => clearTimeout(timeoutRef.current);
//   }, [current]);

//   return (
//     <section className="relative w-full aspect-[16/6.2] overflow-hidden">
//       {images.map((img, index) => (
//         <div
//           key={index}
//           className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
//             current === index ? "opacity-100 z-10" : "opacity-0 z-0"
//           }`}
//         >
//           <img
//             src={img}
//             alt={`Slide ${index + 1}`}
//             className="w-full h-full object-cover block"
//           />
//         </div>
//       ))}

//       {/* Previous Button */}
//       <button
//         onClick={prevSlide}
//         className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white text-black p-3 rounded-r z-20 opacity-50 shadow hover:bg-gray-100"
//       >
//         ❮
//       </button>

//       {/* Next Button */}
//       <button
//         onClick={nextSlide}
//         className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-white text-black p-3 rounded-l z-20 opacity-50 shadow hover:bg-gray-100"
//       >
//         ❯
//       </button>

//       {/* Dots */}
//       <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex gap-2 z-20">
//         {images.map((_, index) => (
//           <button
//             key={index}
//             onClick={() => setCurrent(index)}
//             className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
//               current === index ? "bg-white" : "bg-white/50"
//             }`}
//           ></button>
//         ))}
//       </div>
//     </section>
//   );
// }

// import { useEffect, useRef, useState } from "react";

// export default function Slider() {
//   const [sliders, setSliders] = useState([]);
//   const [current, setCurrent] = useState(0);
//   const timeoutRef = useRef(null);
//   const delay = 5000;

//   // Fetch sliders from backend
//   const fetchSliders = async () => {
//     try {
//       const res = await fetch(
//         "https://tyka.premierhostings.com/backend/api/sliders"
//       );
//       const data = await res.json();

//       if (data?.data?.length > 0) {
//         // ✅ Make sure each slider has a proper image URL
//         const formatted = data.data.map((item) => ({
//           ...item,
//           imageUrl: item.background_image_url
//             ? item.background_image_url
//             : `https://tyka.premierhostings.com/backend/storage/${item.background_image}`,
//         }));
//         setSliders(formatted);
//       } else {
//         console.warn("No sliders found from API");
//       }
//     } catch (error) {
//       console.error("Error fetching sliders:", error);
//     }
//   };

//   useEffect(() => {
//     fetchSliders();
//   }, []);

//   const nextSlide = () =>
//     setCurrent((prev) =>
//       sliders.length > 0 ? (prev + 1) % sliders.length : 0
//     );
//   const prevSlide = () =>
//     setCurrent((prev) =>
//       sliders.length > 0 ? (prev - 1 + sliders.length) % sliders.length : 0
//     );

//   // Auto-slide
//   useEffect(() => {
//     if (sliders.length > 0) {
//       timeoutRef.current = setTimeout(nextSlide, delay);
//     }
//     return () => clearTimeout(timeoutRef.current);
//   }, [current, sliders]);

//   if (sliders.length === 0) {
//     return (
//       <section className="relative w-full aspect-[16/6.2] flex items-center justify-center bg-gray-200 text-gray-600">
//         No sliders available
//       </section>
//     );
//   }

//   return (
//     <section className="relative w-full aspect-[16/6.2] overflow-hidden">
//       {sliders.map((slider, index) => (
//         <div
//           key={slider.id}
//           className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
//             current === index ? "opacity-100 z-10" : "opacity-0 z-0"
//           }`}
//         >
//           <img
//             src={slider.imageUrl}
//             alt={slider.button_name || `Slide ${index + 1}`}
//             className="w-full h-full object-cover block"
//             onError={(e) => (e.target.src = "/placeholder.jpg")}
//           />
//         </div>
//       ))}

//       {/* Previous Button */}
//       <button
//         onClick={prevSlide}
//         className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white text-black p-3 rounded-r z-20 opacity-50 shadow hover:bg-gray-100"
//       >
//         ❮
//       </button>

//       {/* Next Button */}
//       <button
//         onClick={nextSlide}
//         className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-white text-black p-3 rounded-l z-20 opacity-50 shadow hover:bg-gray-100"
//       >
//         ❯
//       </button>

//       {/* Dots */}
//       <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex gap-2 z-20">
//         {sliders.map((_, index) => (
//           <button
//             key={index}
//             onClick={() => setCurrent(index)}
//             className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
//               current === index ? "bg-white" : "bg-white/50"
//             }`}
//           ></button>
//         ))}
//       </div>
//     </section>
//   );
// }

import { useEffect, useRef, useState } from "react";

export default function Slider() {
  const [sliders, setSliders] = useState([]);
  const [current, setCurrent] = useState(0);
  const timeoutRef = useRef(null);
  const delay = 5000;

  // Fetch sliders from backend
  const fetchSliders = async () => {
    try {
      const res = await fetch(
        "https://tyka.premierhostings.com/backend/api/site-slider"
      );
      const data = await res.json();

      if (data?.data?.length > 0) {
        const formatted = data.data.map((item) => ({
          ...item,
          imageUrl: item.background_image_url
            ? item.background_image_url
            : `https://tyka.premierhostings.com/backend/storage/${item.background_image}`,
        }));
        setSliders(formatted);
      } else {
        setSliders([]); // Ensure empty array
      }
    } catch (error) {
      console.error("Error fetching sliders:", error);
      setSliders([]); // Fallback to empty on error
    }
  };

  useEffect(() => {
    fetchSliders();
  }, []);

  const nextSlide = () =>
    setCurrent((prev) =>
      sliders.length > 0 ? (prev + 1) % sliders.length : 0
    );
  const prevSlide = () =>
    setCurrent((prev) =>
      sliders.length > 0 ? (prev - 1 + sliders.length) % sliders.length : 0
    );

  // Auto-slide
  useEffect(() => {
    if (sliders.length > 0) {
      timeoutRef.current = setTimeout(nextSlide, delay);
    }
    return () => clearTimeout(timeoutRef.current);
  }, [current, sliders]);

  // 🟢 Don't render anything if no sliders exist
  if (sliders.length === 0) return null;

  return (
    <section className="relative w-full aspect-[16/6.2] overflow-hidden">
      {sliders.map((slider, index) => (
        <a
          key={slider.id}
          href={slider.target_url || "#"}
          target="_blank"
          rel="noopener noreferrer"
          className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
            current === index ? "opacity-100 z-10" : "opacity-0 z-0"
          }`}
        >
          <img
            src={slider.imageUrl}
            alt={slider.button_name || `Slide ${index + 1}`}
            className="w-full h-full object-cover block cursor-pointer"
            onError={(e) => (e.target.src = "/placeholder.jpg")}
          />
        </a>
      ))}

      {/* Previous Button */}
      <button
        onClick={prevSlide}
        className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white text-black p-3 rounded-r z-20 opacity-50 shadow hover:bg-gray-100"
      >
        ❮
      </button>

      {/* Next Button */}
      <button
        onClick={nextSlide}
        className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-white text-black p-3 rounded-l z-20 opacity-50 shadow hover:bg-gray-100"
      >
        ❯
      </button>

      {/* Dots */}
      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex gap-2 z-20">
        {sliders.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
              current === index ? "bg-white" : "bg-white/50"
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
}
